<template>
  <div>
    <div class="mask"></div>
    <div class="wrap">
      <div class="head border-bottom">
        <h3>添加二维码或链接至宣传渠道</h3>
        <h5>长按保存二维码</h5>
        <div class="img-wrap">
          <img v-lazy="qrImg" alt="">
        </div>
        <!--<div class="time">
          二维码过期时间为：2018-7-28
        </div>-->
      </div>
      <div class="link">
        <h3>点击复制链接</h3>
        <div class="link-text">
          <a href="javacript:;">{{shareUrl}}</a>
          <div class="copy" ref="copytrigger" :data-clipboard-text="shareUrl">复制链接</div>
        </div>
      </div>
      <div class="close" @click="closePopup">
        关闭
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import ClipboardJS from 'clipboard/dist/clipboard.min.js'
export default {
  props: {
    shareUrl: {
      type: String,
      default: ''
    },
    qrImg: {
      type: String,
      default: ''
    }
  },
  methods: {
    closePopup() {
      this.$emit('closePopup')
    }
  },
  mounted() {
    let copy = new ClipboardJS(this.$refs.copytrigger)
    copy.on('success', (e) => {
      this.$toast('复制成功')
    })
  }
}
</script>
<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .mask
    position fixed
    left 0
    right 0
    top 0
    bottom 0
    background rgba(0,0,0,.3)
    z-index 999
  .wrap
    background #fff
    position fixed
    top 50%
    left 50%
    transform translate(-50%,-50%)
    width percentage(600 / 750)
    z-index 9999
    border-radius 6px
    color #333
  .head
    text-align center
    padding-bottom size(40)
    h3
      font-size size(34)
      font-weight 700
      color #333
      padding size(60) 0 size(52)
    h5
      font-size size(30)
      font-weight 700
    .img-wrap
      width size(300)
      min-height size(300)
      margin size(34) auto size(24)
      img
        display block
        width 100%
    .time
      font-size size(24)
      color #999
  .link
    text-align center
    h3
      font-size size(30)
      color #333
      font-weight 700
      padding size(40) 0 size(30)
    .link-text
      line-height size(52)
      position relative
      text-align left
      padding-left size(77)
      padding-right size(220)
      overflow hidden
      white-space nowrap
      text-overflow ellipsis
      a
        font-size size(26)
        color #5e7299
        text-decoration underline
      .copy
        position absolute
        right size(80)
        top 0
        line-height size(50)
        border:1px solid $color-theme
        font-size size(26)
        color $color-theme
        width size(130)
        text-align center
        border-radius 4px
  .close
    margin size(40) size(40) size(55)
    line-height size(70)
    text-align center
    color #ffffff
    font-size size(30)
    font-weight 700
    background $color-theme
    border-radius 4px
    overflow hidden
</style>



// WEBPACK FOOTER //
// src/components/fenxiao/fenxiao-share-popup.vue